module.exports = "<idap-recaptcha (captchaResolved)=\"onCaptchaResolved($event)\"></idap-recaptcha>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/captcha/components/recaptcha-popup.component.html
// module id = ./src/app/captcha/components/recaptcha-popup.component.html
// module chunks = main